import { UserProfileAvatar } from './UserProfileAvatar'
import { UserProfileBarProps } from './interfaces'
import Icon from '../../icons/Icon'
import { ReactElement, useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import { Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { faMapMarker } from '@fortawesome/pro-solid-svg-icons/faMapMarker'
import countries from 'country-data/data/countries.json'
import Image from '@/components/Image'
import { isNil } from '@/helpers/helpers'
import { getAvatarUrl, getForumUser } from '@/helpers/api'
import userAvatarPlaceholder from '@/assets/img/user-avatar.png'

const UserProfileBarStyled = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 105,
  color: theme.palette.common.white,
  display: 'flex',
  alignItems: 'center',
  background: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    height: 80
  }
}))

const UserProfileBar = ({ user }: UserProfileBarProps): ReactElement => {
  const { t } = useTranslation('users')
  const [userAvatarUrl, setUserAvatarUrl] = useState<any>(userAvatarPlaceholder)
  const isPublic = isNil(user.isPublic) || user.isPublic
  const userCountryName =
    countries.find((country) => country.alpha2 === user.address?.country)?.name ?? user.address?.country

  useEffect(() => {
    getForumUser(user.username, false).then((forumUser) => {
      setUserAvatarUrl(getAvatarUrl(forumUser, '66'))
    })
  }, [user])

  return (
    <UserProfileBarStyled>
      <Container>
        <Stack direction="row" spacing={2.5}>
          <UserProfileAvatar flexShrink={0}>
            {!isNil(userAvatarUrl) && <Image src={userAvatarUrl} alt={user.username} width={66} height={66} />}
          </UserProfileAvatar>
          <Stack flexGrow={1} direction="column" spacing={1} justifyContent="center">
            <Typography variant="userProfileTitle">{user.username}</Typography>
            {!isNil(userCountryName) && (
              <Typography variant="userProfileSubtitle">
                {userCountryName} <Icon icon={faMapMarker} />
              </Typography>
            )}
          </Stack>
          <Stack justifyContent="center">
            <Typography variant="h2" textTransform="uppercase">
              {isPublic ? t('publicProfile') : t('privateProfile')}
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </UserProfileBarStyled>
  )
}

export default UserProfileBar
